import React from 'react';
import { IconProps } from '.';

const SvgCategoryFashion = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M9.25 2.25h.8V3c0 .426.178.741.489.972.33.246.836.41 1.461.41.625 0 1.132-.164 1.461-.41A1.15 1.15 0 0 0 13.95 3v-.75h.8c.638 0 1.302 0 1.976.212.717.227 1.383.67 2.118 1.443.839.883 1.48 2.406 1.941 3.832.473 1.46.8 2.963.955 3.922l.092.565-3.682 1.68v7.846H5.85v-7.847l-3.682-1.68.092-.564c.155-.96.482-2.461.955-3.922.461-1.426 1.102-2.95 1.941-3.832.735-.774 1.401-1.216 2.118-1.443.674-.212 1.338-.212 1.975-.212Zm-3.4 10.005V9.632h1.5V20.25h9.3V9.632h1.5v2.623l2.01-.917c-.168-.871-.44-2.021-.802-3.14-.458-1.415-1.017-2.645-1.602-3.26-.615-.648-1.074-.916-1.482-1.045-.282-.09-.568-.123-.926-.135a2.655 2.655 0 0 1-.991 1.417c-.647.482-1.49.707-2.357.707-.866 0-1.71-.225-2.357-.707a2.655 2.655 0 0 1-.991-1.417c-.358.012-.644.046-.926.135-.408.129-.867.397-1.482 1.045-.585.615-1.144 1.845-1.602 3.26a27.416 27.416 0 0 0-.802 3.14l2.01.917Z'
        clipRule='evenodd'
      />
      <path fill={color} fillRule='evenodd' d='M14 9.75h-4v-1.5h4v1.5Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgCategoryFashion;
